module.exports = __webpack_public_path__ + "img/logoLS.dbc698c5.webp";